import { db, auth } from "../firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export default {
  name: "BugReportLogic",
  data() {
    return {
      type: "",          // e.g. "Bug" or "Feature"
      summary: "",
      description: "",
      loading: false,
      error: null,
      successMessage: ""
    };
  },
  methods: {
    async submitTicket() {
      this.loading = true;
      try {
        // Ensure the user is signed in
        const user = auth.currentUser;
        if (!user) {
          this.error = "You must be logged in to submit a ticket.";
          this.loading = false;
          return;
        }
        // Build ticket object
        const ticketData = {
          type: this.type || "Bug",
          summary: this.summary.trim(),
          description: this.description.trim(),
          timestamp: serverTimestamp(),
          addedBy: user.uid,
          status: "🔵 Open"
        };
        // Add to /devTickets collection
        await addDoc(collection(db, "devTickets"), ticketData);
        
        this.successMessage = "Ticket submitted successfully!";
        // Clear the form
        this.type = "";
        this.summary = "";
        this.description = "";
      } catch (err) {
        console.error("Error submitting ticket:", err);
        this.error = "Error submitting ticket. Please try again.";
      } finally {
        this.loading = false;
      }
    }
  }
};
